import styled from 'styled-components'

export const CheckListContainer = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;
	width: 100%;
	height: ${props => props.$height || 'auto'};
	overflow-y: scroll;
	padding-right: 4px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		height: auto;
		overflow-y: auto;
	}
`

export const CheckListItem = styled.li`
	padding: 6px 8px;
	cursor: pointer;
	border-radius: 8px;
	color: ${props => props.theme.colors.text.primaryText};

	&:hover {
		background-color: ${props => props.theme.colors.brand.backgroundBlue};
	}
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		padding: 14px 8px;
	}
`

export const CheckListItemContent = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
	position: absolute;
	opacity: 0;
	pointer-events: none;
	height: 0;
	width: 0;
`

export const StyledCheckbox = styled.div`
	width: 18px;
	height: 18px;
	border: 2px solid ${props => props.theme.colors.brand.blueOmint};
	border-radius: 4px;
	background-color: ${props =>
		props.$checked ? props.theme.colors.brand.blueOmint : props.theme.colors.brand.white};
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`

export const EmptyState = styled.div`
	padding: 8px;
	color: ${props => props.theme.colors.text.secondaryText};
	font-size: 14px;
`
